import 'script-loader!jquery'
import 'script-loader!bootstrap/js/dist/util'
import 'script-loader!bootstrap/js/dist/alert'

import Vue from 'vue'
import Router from 'vue-router'
import CreamsIndex from '@/components/pages/creams/index'
import CreamsNew from '@/components/pages/creams/new'
import CreamsEdit from '@/components/pages/creams/edit'
import SelectionsEdit from '@/components/pages/selections/edit'
import Login from '@/components/pages/login'
import { auth, userStorage } from '../services/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/creams',
      component: CreamsIndex,
      meta: {
        authorized: 'creams-edit'
      }
    },
    {
      path: '/creams/new',
      component: CreamsNew,
      meta: {
        authorized: 'creams-edit'
      }
    },
    {
      path: '/creams/edit/:id',
      component: CreamsEdit,
      meta: {
        authorized: 'creams-edit'
      }
    },
    {
      name: 'selectionsEdit',
      path: '/selections/:id',
      component: SelectionsEdit,
      props: true
    },
    {
      path: '/access-denied',
      component: {
        template: '<p>Zugang verweigert.</p>'
      }
    },
    {
      path: '/login',
      component: Login,
      beforeEnter (to, from, next) {
        if (auth.current) return next('/')
        next()
      }
    },
    {
      path: '/',
      redirect () {
        if (auth.isAuthorized('creams-edit')) {
          return '/creams'
        } else if (auth.current.permissions) {
          try {
            const id = auth.current.permissions[0]['selections-edit'][0]
            return `/selections/${id}`
          } catch (err) {
            return '/access-denied'
          }
        } else {
          return '/login'
        }
      }
    }
  ]
})

router.beforeEach(function login (to, from, next) {
  // Already logged in
  if (auth.current) {
    return next()
  }

  // Try to login with credentials from storage
  const { username, password } = userStorage.get()
  auth.login(username, password)
    .then(() => {
      next()
    })
    .catch((reason) => {
      if (reason instanceof Error) throw reason
      if (to.path === '/login') return next()
      next('/login')
    })
})

router.beforeEach(function authorize (to, from, next) {
  if (to.meta.authorized) {
    if (auth.isAuthorized(to.meta.authorized, to.params.id)) {
      return next()
    } else {
      return next(false)
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./app/frontend/router/index.js